import React from "react";

export const AlignmentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.75 14.75H3.75V16.5833H14.75V14.75ZM14.75 7.41667H3.75V9.25H14.75V7.41667ZM3.75 12.9167H20.25V11.0833H3.75V12.9167ZM3.75 20.25H20.25V18.4167H3.75V20.25ZM3.75 3.75V5.58333H20.25V3.75H3.75Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
